<template>
  <div>
    <div class="main_borrow">
      <el-dialog
        class="search-result-wrapper"
        :visible.sync="dialogVisible"
        :before-close="handleDialogClose"
        :title="$t('title.popup.system.borrowArea.search')"
      >
        <el-row class="outside">
          <el-col :span="24">
            <el-form
              @submit.native.prevent
              label-width="141px"
              label-position="left"
              :rules="rules"
              :model="borrowArea"
              ref="borrowArea"
              class="zdyInput"
              hide-required-asterisk
            >
              <!-- オーナー -->
              <el-form-item
                :label="$t('label.popup.system.borrowArea.ownerName')"
                prop="ownerName"
                class="asterisk long-name"
              >
                <div class="row">
                  <div class="edit-content heght-auto">
                    {{borrowArea.ownerName}}
                  </div>
                </div>
              </el-form-item>
              <!-- ビル -->
              <el-form-item
                :label="$t('label.popup.system.borrowArea.buildingName')"
                prop="buildingName"
                class="asterisk"
              >
                <div class="row">
                  <el-input
                    class="new-input-style"
                    maxlength="50"
                    v-model="borrowArea.buildingName"
                    :readonly="true"
                    :placeholder="
                      $t('label.popup.system.borrowArea.selectBuilding')
                    "
                  >
                  </el-input>
                  <select-btn @click="selectBuilding" class="fm-st-btn">{{
                    $t("button.common.select")
                  }}</select-btn>
                </div>
              </el-form-item>
              <!-- エリア -->
              <el-form-item
                :label="$t('label.popup.system.borrowArea.areaName')"
                prop="areaName"
                class="asterisk"
              >
                <div class="row">
                  <el-input
                    class="new-input-style"
                    v-model="borrowArea.areaName"
                    maxlength="50"
                    :readonly="true"
                    :placeholder="
                      $t('label.popup.system.borrowArea.selectArea')
                    "
                  >
                  </el-input>
                  <select-btn @click="selectArea" class="fm-st-btn">{{
                    $t("button.common.select")
                  }}</select-btn>
                </div>
              </el-form-item>

              <!-- 入居年月日 -->

              <el-form-item
                :label="$t('label.popup.system.borrowArea.inTime')"
                prop="begin"
                class="asterisk"
              >
                <div class="new_date_box">
                  <el-date-picker
                    @blur="this.$reset"
                    @change="changeBeginDate"
                    class="pick_date_box"
                    :placeholder="
                      $t('label.system.buildingUse.usedRoom.choice')
                    "
                    size="small"
                    type="date"
                    :clearable="false"
                    v-model="borrowArea.begin"
                    :format="
                      'yyyy年M月d日' + ' ' + '(' + [beginCurrDay] + ')'
                    "
                    :picker-options="begin"
                  />
                </div>
              </el-form-item>

              <!--  退居年月日  -->

              <el-form-item
                :label="$t('label.popup.system.borrowArea.outTime')"
                prop="over"
                class="end_date_item"
              >
                <div class="row">
                  <div class="new_date_box">
                    <el-date-picker
                      @blur="this.$reset"
                      class="pick_date_box"
                      @change="changeEndDate"
                      :placeholder="
                        $t('label.system.buildingUse.usedRoom.choice')
                      "
                      size="small"
                      :clearable="false"
                      v-model="borrowArea.over"
                      :format="
                        'yyyy年M月d日' + ' ' + '(' + [endCurrDay] + ')'
                      "
                      type="date"
                      :picker-options="over"
                    />
                  </div>
                  <select-btn @click="borrowArea.over = null" class="fm-st-btn">
                    クリア
                  </select-btn>
                </div>
              </el-form-item>

              <!-- 借入曜日 -->
              <el-form-item
                :label="$t('label.popup.system.borrowArea.borrowWeek')"
              >
                <day
                  :day="borrowArea.borrowWeek"
                  @getDayValue="getDayValue"
                ></day>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <el-row class="text-center">
          <narrowDown
            @click="selectBorrowArea(borrowArea)"
            class="submit_button"
          >
            {{ $t("button.common.data.setup") }}
          </narrowDown>
          <cancelNarrowDown class="link-primary" @click="handleDialogClose">
            {{ $t("button.common.cancel") }}
          </cancelNarrowDown>
        </el-row>
      </el-dialog>
    </div>

    <building-search-popup
      :ownerIdParam="borrowArea.ownerId"
      :buildingExIdParam="borrowArea.buildingExId"
      :buildingNameParam="borrowArea.buildingName"
      :includeDeleteDataFlag="false"
      :visible.sync="showSelectBuildingDialog"
      @on-selected="handlerBuildSelected">
    </building-search-popup>

    <area-search-popup
      :ownerIdParam="borrowArea.ownerId"
      :buildingIdParam="borrowArea.buildingId"
      :areaNameParam="borrowArea.areaName"
      :includeDeleteDataFlag="false"
      :visible.sync="showSelectAreaDialog"
      @on-selected="handlerAreaSelected">
    </area-search-popup>

    <el-dialog-prompt
      :centerDialogVisibleParam.sync="centerDialogVisibleIsShow"
      :msgParam="msgParam"
      @on-isPassParam="saveData">
    </el-dialog-prompt>
  </div>
</template>

<script>
import BuildingSearchPopup from "@/components/system/popup/BuildingSearchPopup";
import AreaSearchPopup from "@/components/system/popup/AreaSearchPopup";
import SystemManageApi from "@/api/SystemManageApi";
import errorCodeMsg from "@/utils/error-code-msg";
import selectBtn from "@/components/common/generalButton/Select";
import day from "@/components/common/checkbox/WeekDaysCheckBox";
import narrowDown from "@/components/common/generalButton/NarrowDown";
import cancelNarrowDown from "@/components/common/generalButton/CancelNarrowDown";
import elDialogPrompt from "@/components/common/el-dialog-prompt";
import statusErrorCodeMsg from "@/utils/status-error-msg"

const weeksDay = ["日", "月", "火", "水", "木", "金", "土"];
const EVENT_ON_SELECTED = "on-selected";

export default {
  name: "BorrowAreaPopup",
  components: {
    AreaSearchPopup: AreaSearchPopup,
    BuildingSearchPopup: BuildingSearchPopup,
    selectBtn: selectBtn,
    day: day,
    cancelNarrowDown: cancelNarrowDown,
    narrowDown: narrowDown,
    elDialogPrompt: elDialogPrompt,
  },
  props: {
    visible: Boolean,
    tenantId: String,
    ownerId: String,
    ownerExId: String,
    ownerName: String,
    buildingId: String,
    buildingExId: String,
    buildingName: String,
    areaId: String,
    areaName: String,
    time: [],
    borrowWeek: [],
  },
  data() {
    var checkbegin = (rule, value, callback) => {
      this.$CheckFromToDate(this.borrowArea.begin, this.borrowArea.over, null, null,
        this.$t("label.popup.system.borrowArea.inTime"),this.$t("label.popup.system.borrowArea.outTime"),
        callback
      )
    };
    var checkend = () => {
       this.$refs["borrowArea"].validateField("begin");
    };
    return {
      msgParam: this.$t("message.common.settingConfirm", {
        field: this.$t("title.popup.system.borrowArea.promptInfo"),
      }),
      centerDialogVisibleIsShow: false,
      beginCurrDay: "",
      endCurrDay: "",
      dateFormat: "",
      begin: null,
      over: null,
      rules: {
        ownerName: [
          {
            required: true,
            trigger: "change",
            message: this.$t("message.common.validation.required", {
              field: this.$t("label.popup.system.borrowArea.ownerName"),
            }),
          },
        ],
        buildingName: [
          {
            required: true,
            trigger: "change",
            message: this.$t("message.common.validation.required", {
              field: this.$t("label.popup.system.borrowArea.buildingName"),
            }),
          },
        ],
        areaName: [
          {
            required: true,
            trigger: "change",
            message: this.$t("message.common.validation.required", {
              field: this.$t("label.popup.system.borrowArea.areaName"),
            }),
          },
        ],
        times: [
          {
            required: true,
            trigger: "change",
            message: this.$t("message.common.validation.required", {
              field: this.$t("label.popup.system.borrowArea.times"),
            }),
          },
        ],
        begin: [
          {
            required: true,
            trigger: "change",
            message: this.$t("message.common.validation.required", {
              field: this.$t("label.popup.system.borrowArea.inTime"),
            }),
          },
          { validator: checkbegin, trigger: "change" },
        ],
        over: [{ validator: checkend, trigger: "change" }],
      },
      borrowArea: {
        tenantId: null,
        ownerId: this.ownerId,
        ownerExId: this.ownerExId,
        ownerName: this.ownerName,
        buildingId: null,
        buildingExId: null,
        buildingName: null,
        floorName:null,
        floorId:null,
        areaId: null,
        areaName: null,
        begin: null,
        over: null,
        borrowWeek: [],
      },
      times: {
        startDate: null,
        endDate: null,
      },
      dialogVisible: this.visible,
      showSelectBuildingDialog: false,
      showSelectAreaDialog: false,
    };
  },
  watch: {
    visible: function (value) {
      this.dialogVisible = value;
    },
    ownerId: function (value) {
      this.borrowArea.ownerId = value;
    },
    ownerExId: function (value) {
      this.borrowArea.ownerExId = value;
    },
    ownerName: function (value) {
      this.borrowArea.ownerName = value;
    },
  },
  methods: {
    getDayValue(val) {
      this.borrowArea.borrowWeek = val;
    },
    selectBuilding: function () {
      this.showSelectBuildingDialog = true;
      this.borrowArea.areaId = null;
      this.borrowArea.areaName = null;
    },
    selectArea: function () {
      this.showSelectAreaDialog = true;
    },
    handlerOwnerSelected: function (owner) {
      this.borrowArea.ownerName = owner.name;
      this.borrowArea.ownerId = owner.id;
      this.borrowArea.ownerExId = owner.exId;
      this.borrowArea.tenantId = owner.tenantId;
    },
    handlerBuildSelected: function (build) {
      this.borrowArea.ownerName = build.ownerName;
      this.borrowArea.ownerId = build.ownerId;
      this.borrowArea.ownerExId = build.ownerExId;
      this.borrowArea.buildingId = build.buildingId;
      this.borrowArea.buildingName = build.buildingName;
      this.borrowArea.buildingExId = build.buildingExId;
    },
    handlerAreaSelected: function (area) {
      this.borrowArea.ownerId = area.ownerId;
      this.borrowArea.ownerExId = area.ownerExId;
      this.borrowArea.ownerName = area.ownerName;
      this.borrowArea.buildingId = area.buildingId;
      this.borrowArea.buildingExId = area.buildingExId;
      this.borrowArea.buildingName = area.buildingName;
      this.borrowArea.floorName = area.floorName;
      this.borrowArea.floorId = area.floorId;
      this.borrowArea.areaId = area.areaId;
      this.borrowArea.areaName = area.areaName;
    },
    selectBorrowArea: function () {
      var rule = this.rules.over[0];
      this.rules.over.pop(0);
      this.$refs["borrowArea"].validate((valid) => {
        this.rules.over.push(rule);
        if (!this.borrowArea.over) {
          this.borrowArea.beginStr = this.formatTime(
            this.borrowArea.begin,
            "yyyy/MM/dd"
          );
          this.borrowArea.overStr = "";
        } else {
          this.borrowArea.beginStr = this.formatTime(
            this.borrowArea.begin,
            "yyyy/MM/dd"
          );
          this.borrowArea.overStr = this.formatTime(
            this.borrowArea.over,
            "yyyy/MM/dd"
          );
        }
        if (valid) {
          this.borrowArea.tenantId = this.tenantId;
          this.centerDialogVisibleIsShow = true;
        }
      });
    },

    saveData() {
      if (this.areaId) {
        SystemManageApi.tenantAreaRelationUpdate({
          tenantId: this.tenantId,
          areaId: this.borrowArea.areaId,
          moveInDate: this.formatSubsmitDate(this.borrowArea.beginStr),
          moveOutDate: this.formatSubsmitDate(this.borrowArea.overStr),
          dayList: this.borrowArea.borrowWeek,
        })
          .catch((error) => {
            errorCodeMsg(error, this);
          })
          .then(() => {});
      } else {
        SystemManageApi.tenantAreaRelationCreate({
          tenantId: this.tenantId,
          areaId: this.borrowArea.areaId,
          moveInDate: this.formatSubsmitDate(this.borrowArea.beginStr),
          moveOutDate: this.formatSubsmitDate(this.borrowArea.overStr),
          dayList: this.borrowArea.borrowWeek,
        })
          .catch((error) => {
            errorCodeMsg(error, this);
          })
          .then(({ data }) => {
            if (!statusErrorCodeMsg(data.statusCode, this, 'BorrowArea')) {
              return;
            }
            this.saveSuccess();
          });
      }

    },
    saveSuccess() {
      this.$messageIotSuccess(this.$t("message.common.settingSuccess", {
        field: this.$t("title.popup.system.borrowArea.promptInfo"),
      }));
      this.borrowArea.begin = this.borrowArea.beginStr;
      this.borrowArea.over = this.borrowArea.overStr;
      this.$emit(EVENT_ON_SELECTED, this.borrowArea);
      this.dialogVisible = false;
      this.$emit("update:visible", false);
      this.clearSearchParams();
    },
    formatSubsmitDate(val) {
      return new Date(val);
      // return dateVal.getFullYear()
      //   + '-'
      //   + (dateVal.getMonth() + 1)
      //   + '-' + dateVal.getDate()
      //   +" 00:00:00";
    },
    formatTime(date, fmt) {
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      let o = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds(),
      };
      for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          let str = o[k] + "";
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length === 1 ? str : this.padLeftZero(str)
          );
        }
      }
      return fmt;
    },
    padLeftZero(str) {
      return ("00" + str).substr(str.length);
    },
    handleDialogClose: function () {
      this.dialogVisible = false;
      this.$emit("update:visible", false);
      this.clearSearchParams();
    },
    clearSearchParams: function () {
      this.borrowArea.buildingId = null;
      this.borrowArea.buildingExId = null;
      this.borrowArea.buildingName = null;
      this.borrowArea.floorName = null;
      this.borrowArea.floorId = null;
      this.borrowArea.areaId = null;
      this.borrowArea.areaName = null;
      this.borrowArea.begin = null;
      this.borrowArea.over = null;
      this.borrowArea.beginStr = null;
      this.borrowArea.overStr = null;
      this.borrowArea.borrowWeek = [];
      this.$refs["borrowArea"].resetFields();
    },
    changeBeginDate(val) {
      this.beginCurrDay = weeksDay[val.getDay()];
    },
    changeEndDate(val) {
      this.endCurrDay = weeksDay[val.getDay()];
    },
  },
  mounted() {
    this.dateFormat =
      "yyyy" +
      this.$t("label.system.buildingUse.usedRoom.yyyy") +
      "MM" +
      this.$t("label.system.buildingUse.usedRoom.MM") +
      "dd" +
      this.$t("label.system.buildingUse.usedRoom.dd");
  },
};
</script>

<style lang="scss" scoped>
::v-deep .new-input-style {
  width: 324px;
  .el-input__inner {
    width: 324px;
    height: 44px !important;
    border-radius: 8px !important;
    background: #f2f2ed;
    border: none;
    box-shadow: -2px -2px 5px #ffffff inset, -2px -2px 5px #ffffff inset,
      4px 5px 5px #e6e6e1 inset, 4px 5px 5px #e6e6e1 inset;
  }
}
.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.select-btn {
  width: 68px;
  height: 44px;
}
.select {
  width: 250px;
  border: 3px solid #2699fb;
  height: 40px;
  line-height: 34px;
  text-align: center;
  padding: 0;
  padding-left: 10px;
  color: #2699fb;
  font-weight: bold;
  margin-left: 316px;
}
.outside {
  // margin-left: 102px;
  display: inline-block;
}
.title {
  margin-left: 98px;
  font-size: 30px;
  font-weight: bold;
  color: #7f7f7f;
}
// 修改当前popup内部样式
.main_borrow {
  ::v-deep.el-dialog__header .el-dialog__headerbtn {
    display: none;
  }
}
.main_borrow {
  ::v-deep.el-dialog {
    width: 695px;
    background-color: #f2f2ed;
    border-radius: 3px !important;
  }
}
.main_borrow {
  ::v-deep.el-dialog__body {
    padding-top: 0;
    // padding-left: 76px;
    padding-bottom: 0;
  }
}
.main_borrow {
  ::v-deep .el-dialog__header .el-dialog__headerbtn .el-icon-close {
    font-size: 16px;
    margin-left: 0;
  }
}
.main_borrow {
  ::v-deep .el-dialog__headerbtn {
    top: 26px;
  }
}
.label {
  color: #2699fb;
  font-size: 14px;
}

.fm-st-btn ::v-deep button {
  width: 68px !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  margin-left: 7px;
}
.pick_date_box {
  border-radius: 5px;
  width: 180px !important;
  height: 40px !important;
  border: none !important;
  background-color: #f2f2ed;
  float: left;
  ::v-deep .el-icon-date:before {
    display: none;
  }
  ::v-deep .el-icon-date:after {
    display: none;
  }
  ::v-deep.el-input__inner {
    border: none;
    height: 40px;
    padding-left: 10px !important;
    border-radius: 4px !important;
    background-color: #f2f2ed;
    // box-shadow: -2px -2px 5px #ffffff , -2px -2px 5px #ffffff ,
    // 4px 5px 5px #E6E6E1 , 4px 5px 5px #E6E6E1 ;
    box-shadow: -3px -2px 2px #ffffff, 3px 3px 2px #e6e6e1;
  }
}

.img-size {
  position: relative;
  left: -25px;
  top: 6px;
  -webkit-pointer-events: none;
  -moz-pointer-events: none;
  -ms-pointer-events: none;
  -o-pointer-events: none;
  pointer-events: none;
}
.new_date_box {
  width: 190px;
  height: 40px;
  border-radius: 4px;
  ::v-deep.el-input--prefix {
    .el-input__inner {
      padding-left: 9px;
    }
  }
}

// ::v-deep .zdyInput .el-input__inner {
//   width: 364px;
// }
.el-form-item {
  height: 65px;
  margin-bottom: 0px;
}
.submit_button {
  margin-bottom: 20px;
}

::v-deep .el-form-item__error {
  margin-top: -16px !important;
  padding-top: 0 !important;
}
::v-deep .asterisk {
  .el-form-item__label::after{
    content: "*";
    color: #F56C6C;
    margin-right: 4px;
  }
}
.edit-content {
  height: 40px;
}
.long-name {
  height:auto;
  width:550px;
  padding-bottom:25px;
}
.heght-auto{
  height:auto;
}
</style>
